import React, { useState } from "react";
import { Link } from "react-router-dom";
import FsLightbox from "fslightbox-react";

import photo1 from "../../assets/img/gallery/galeria1.jpg";
import photo2 from "../../assets/img/gallery/galeria2.jpg";
import photo3 from "../../assets/img/gallery/galeria3.jpg";
import photo4 from "../../assets/img/gallery/galeria4.jpg";
import photo5 from "../../assets/img/gallery/galeria5.jpg";
import photo6 from "../../assets/img/gallery/galeria6.jpg";
import photo7 from "../../assets/img/gallery/galeria7.jpg";
import photo8 from "../../assets/img/gallery/galeria8.jpg";
import photo9 from "../../assets/img/gallery/galeria9.jpg";
import photo10 from "../../assets/img/gallery/galeria10.jpg";

import photo11 from "../../assets/img/gallery/galeria11.jpg";
import photo12 from "../../assets/img/gallery/galeria12.jpg";
import photo13 from "../../assets/img/gallery/galeria13.jpg";
import photo14 from "../../assets/img/gallery/galeria14.jpg";
import photo15 from "../../assets/img/gallery/galeria15.jpg";
import photo16 from "../../assets/img/gallery/galeria16.jpg";
import photo17 from "../../assets/img/gallery/galeria17.jpg";
import photo18 from "../../assets/img/gallery/galeria18.jpg";
import photo19 from "../../assets/img/gallery/galeria19.jpg";
import photo20 from "../../assets/img/gallery/galeria20.jpg";

export default function Gallery() {
  const [activeImage, setActiveImage] = useState(1);
  const [images, setImages] = useState([
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8,
    photo9,
    photo10,
    photo11,
    photo12,
    photo13,
    photo14,
    photo15,
    photo16,
    photo17,
    photo18,
    photo19,
    photo20,
  ]);

  const [toggler, setToggler] = useState(false);
  const [tabMenu, tabActive] = useState({ page1: true });
  const handleClick = (index) => {
    setActiveImage(index);
    setToggler(!toggler);
  };

  return (
    <>
      <section className="profile fix pt-5 pb-2">
        <div className="container-xxl">
          <div className="row">
            <div className="col-lg-12">
              <h1 style={{ textAlign: "center" }}>Galeria</h1>
            </div>
            <div className="col-auto mx-auto">
              <div className="button-group filter-button-group mb-4 d-flex">
                <button
                  className={`${tabMenu.page1 && "active"}`}
                  onClick={() => tabActive({ page1: true })}
                  data-filter="*"
                >
                  1
                </button>
                <button
                  className={`${tabMenu.page2 && "active"}`}
                  onClick={() => tabActive({ page2: true })}
                  data-filter="*"
                >
                  2{" "}
                </button>
              </div>
            </div>
            <div className="col-lg-12">
              {tabMenu.page1 && (
                <div className="masonry-gallery-huge gallery-grid-page-1">
                  <>
                    {Array.from(Array(10).keys()).map((idx) => (
                      <GalleryItem
                        key={idx}
                        idx={idx + 1}
                        img={images[idx]}
                        handleClick={handleClick}
                      />
                    ))}
                  </>
                </div>
              )}

              {tabMenu.page2 && (
                <div className="masonry-gallery-huge gallery-grid-page-2">
                  <>
                    {Array.from(Array(10).keys()).map((idx) => (
                      <GalleryItem
                        key={idx + 10}
                        idx={idx + 11}
                        img={images[idx + 10]}
                        handleClick={handleClick}
                      />
                    ))}
                  </>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <FsLightbox
        toggler={toggler}
        sources={images.filter((e) => e)}
        slide={activeImage}
      />
    </>
  );
}

const GalleryItem = ({ idx, img, handleClick }) => {
  return (
    <div className={`gallery-photo${(idx > 10) ? (idx-10) : idx}`}>
      <Link to="#" className="popup-image">
        <figure className="gallery-image" onClick={() => handleClick(idx)} style={{overflow: "hidden"}}>
          <img src={img} alt="img" className="img"/>
        </figure>
      </Link>
    </div>
  );
};
